import { render } from "./CustomersKpiCard.vue?vue&type=template&id=18be8e34&scoped=true"
import script from "./CustomersKpiCard.vue?vue&type=script&lang=js"
export * from "./CustomersKpiCard.vue?vue&type=script&lang=js"

import "./CustomersKpiCard.vue?vue&type=style&index=0&id=18be8e34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18be8e34"]])

export default __exports__